import './SupportView.scss';

import SupportView from './SupportView';

export default SupportView;
